import {
  VaniaChartContainer,
  VaniaGlassPanel,
} from '@vanialabs/ui-engine';
import type { MonitoringSnapshot } from '../../monitoring/types/monitoring.types';
import type { DashboardOverview } from '../types/dashboard.types';
import { DashboardStatusChart, DashboardTrendChart } from './DashboardCharts';
import { DashboardHealthCenter } from './DashboardHealthCenter';
import { ControlPlaneActivity } from './ControlPlaneActivity';
import { ControlPlaneMetrics } from './ControlPlaneMetrics';
import { ControlPlaneQuickActions } from './ControlPlaneQuickActions';

interface CommandCenterDashboardProps {
  dashboard: DashboardOverview;
  monitoring: MonitoringSnapshot | null;
  monitoringLoading: boolean;
  monitoringError: string | null;
}

export function CommandCenterDashboard({ dashboard, monitoring, monitoringLoading, monitoringError }: CommandCenterDashboardProps) {
  const health = ['API', 'Database', 'Redis'];

  return (
    <section className="vania-command-surface">
      <div className="vania-command-content">
        <ControlPlaneMetrics dashboard={dashboard} monitoring={monitoring} monitoringLoading={monitoringLoading} />
        <div className="vania-command-grid">
        <VaniaChartContainer title="تحلیل عملیات" subtitle="روند روزانه"><DashboardTrendChart points={dashboard.charts.revenue_trend.map((item, index) => ({ ...item, orders: dashboard.charts.orders_trend[index]?.value ?? 0, users: dashboard.charts.user_growth_trend[index]?.users ?? 0 }))} /></VaniaChartContainer>
        <VaniaChartContainer title="توزیع وضعیت" subtitle="سفارش‌ها"><DashboardStatusChart items={dashboard.orders.status_distribution} total={dashboard.orders.order_count} /></VaniaChartContainer>
        </div>
        <div className="vania-command-bottom-grid">
        <ControlPlaneActivity monitoring={monitoring} />
        <VaniaGlassPanel className="vania-command-parent-panel"><div className="vania-command-card-heading"><h2>دسترسی سریع</h2><span>عملیات پرکاربرد</span></div><ControlPlaneQuickActions /></VaniaGlassPanel>
        <VaniaGlassPanel className="vania-command-parent-panel"><div className="vania-command-card-heading"><h2>وضعیت سرویس‌ها</h2><span>زیرساخت عملیاتی</span></div><DashboardHealthCenter services={health} monitoring={monitoring} loading={monitoringLoading} errorMessage={monitoringError} /></VaniaGlassPanel>
        </div>
      </div>
    </section>
  );
}
